import { Component } from '@angular/core';

@Component({
  selector: 'app-ap-promo-card',
  standalone: true,
  imports: [],
  templateUrl: './ap-promo-card.component.html',
  styleUrl: './ap-promo-card.component.scss',
})
export class ApPromoCardComponent {
  whatsapp_link = 'https://api.whatsapp.com/send?phone=573152757888&text=Complementar%20AP%20Motos';
}
